









import { LayoutPlugin, NavbarPlugin } from 'bootstrap-vue';
import { Vue, Component } from 'vue-property-decorator';

import Navbar from '@/components/navbar.vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(LayoutPlugin);
Vue.use(NavbarPlugin);

@Component({
    components: {
        Navbar
    }
})
export default class App extends Vue {}
